import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { HOLIDAYS_API } from "@constants/api";
import { AlertResultApi } from "@utils//alert";

export const initialStateHolidays = {
  listHolidays: [],
  fetching: "done",
};

const Holiday = types.model({
  id: types.number,
  schoolId: types.maybeNull(types.number),
  academicYearId: types.number,
  name: types.maybeNull(types.string),
  date: types.maybeNull(types.string),
  type: types.string,
  createdAt: types.string,
  updatedAt: types.string,
});

export const Holidays = types
  .model({
    listHolidays: types.maybeNull(types.array(Holiday)),
    fetching: types.string,
    status: types.maybeNull(types.number),
  })
  .actions((self) => ({
    getHolidays: flow(function* getHolidays(
      token: string,
      academicYearId: number
    ) {
      self.fetching = "pending";
      self.listHolidays = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.get(HOLIDAYS_API, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            Filter: JSON.stringify({ AcademicYearId: academicYearId }),
            PageSize: 1000,
          },
        });
        console.log("getHolidays", result);
        self.fetching = "done";
        self.status = result.status;
        self.listHolidays = result.data;
      } catch (error) {
        // ... including try/catch error handling
        self.fetching = "error";
        self.status = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
  }))
  .views((self) => ({}));

export type HolidaysType = Instance<typeof Holidays>;
